import { ProgressBar } from '../../../ProgressBar'
import { useRequestProfileTabInternalTasksChecklistActions } from '../RequestProfileTabInternalTasks.hooks'
import { getChecklistProgress } from '../RequestProfileTabInternalTasks.utils'
import { RequestProfileTabInternalTasksChecklistAddItem } from '../RequestProfileTabInternalTasksChecklistAddItem'
import { RequestProfileTabInternalTasksChecklistHeader } from '../RequestProfileTabInternalTasksChecklistHeader'
import { RequestProfileTabInternalTasksChecklistItem } from '../RequestProfileTabInternalTasksChecklistItem'

import * as styles from './RequestProfileTabInternalTasksChecklist.module.css'

function RequestProfileTabInternalTasksChecklist({ checklist }) {
  const {
    handleCancelAddChecklistItem,
    handleOpenDeleteModal,
    handleShowAddChecklistItem,
    handleSubmitAddChecklistItem,
    isAddChecklistItemLoading,
    isAddingChecklistItem,
  } = useRequestProfileTabInternalTasksChecklistActions(checklist)

  const progress = getChecklistProgress(checklist.items)

  return (
    <div className={styles.RequestProfileTabInternalTasksChecklist}>
      <RequestProfileTabInternalTasksChecklistHeader
        name={checklist.name}
        progress={progress}
        onDelete={handleOpenDeleteModal}
      />
      <ProgressBar progress={progress} />
      <div className={styles.items}>
        {checklist.items.map(checklistItem => (
          <RequestProfileTabInternalTasksChecklistItem
            checklistId={checklist.id}
            checklistItem={checklistItem}
            key={checklistItem.id}
          />
        ))}
      </div>
      <RequestProfileTabInternalTasksChecklistAddItem
        isAdding={isAddingChecklistItem}
        isLoading={isAddChecklistItemLoading}
        onCancel={handleCancelAddChecklistItem}
        onShow={handleShowAddChecklistItem}
        onSubmit={handleSubmitAddChecklistItem}
      />
    </div>
  )
}

export default RequestProfileTabInternalTasksChecklist
